// El backend responde `{ error: 'texto' }` o `{ error: { code, message } }` según
// el controller. Guardar el objeto en el estado y renderizarlo tira abajo la pantalla.
export function mensajeDeError(e, fallback) {
  const error = e?.response?.data?.error;
  const msg = typeof error === 'string' ? error : error?.message;
  return msg || fallback;
}
